import type { ReactNode } from "react";

export type TabItemProps = {
  children: ReactNode;
  label: string;
  disabled?: boolean;
};

export const TabItem = ({ children }: TabItemProps) => {
  return <>{children}</>;
};
